import { Button, Typography, Container } from '@material-ui/core'
import React, { useState } from 'react'
import DataCard from './DataCard'
import FadeIn from 'react-fade-in/lib/FadeIn'


const WasteHeatCalculator = () => {

  const [ eer, setEer ] = useState('')
  const [ elect, setElect ] = useState('')
  const [ result, setResult ] = useState('')

  // Event-funktio, jossa input-valuet lasketaan float-lukuina ja palautetaan result-muuttujaksi
  const calculateWasteHeat = (e) => {
    e.preventDefault()
    console.log(elect, eer)
    let sum = (parseFloat(elect) / 2 * parseFloat(eer)) + (parseFloat(elect) / 2)
    console.log(parseFloat(sum))
    setResult(parseFloat(sum))
  }

  return (
    <FadeIn transitionDuration="3000">
      <div>
        <Typography variant="h3" style={{ color:'white' }}>Waste Heat Calculator<br></br><br></br></Typography>
        <Container>
          <div style={{
            float:'left',
            width:'50%'
          }}>
            <div className="Pilot-areas">
              <Typography variant="subtitle1"> </Typography>
              <Typography variant="subtitle1">Disclaimer: Results of this calculator are only estimates. <br></br> <br></br>Energy Efficiency Ratio is the ratio of output cooling energy to input electrical energy at a given operating point and is calculated by: Cooling capacity (kW) / Power Input (kW)<br></br><br></br>In order to calculate cooling capacity you need volume of the refrigerated room, multiplied with required cooling by single cubic metre. If you want simple calculation for household with modern insulation, you need to multiply room volume with 30 watts. This does not take things like number of people or other heat sources into consideration.<br></br><br></br>Example:<br></br> Room floor space 50m&#178; x 2,5m ceiling height x 30 W = 3,75 kW<br></br>Energy efficiency ratio for room this size using a 3 kW HVAC unit would be 1,25<br></br></Typography>
              <br></br>
            </div>
          </div>
        </Container>
        <form onSubmit={calculateWasteHeat} style={{
          float:'right',
          width:'50%'
        }}>
          <div>
            <input
              style={{
                fontSize:'25px',
                width:'100%'
              }}
              type="number"
              placeholder="Energy Efficiency Ratio"
              value={eer}
              onChange={({ target }) => setEer(target.value)}
            />
          </div>
          <div>
            <input
              style={{
                fontSize:'25px',
                width:'100%'
              }}
              type="number"
              onChange={({ target }) => setElect(target.value)}
              placeholder="Amount of electricity consumed by the property"
              value={elect}
            />
          </div>
          <Button
            type="submit"
            style={{
              fontSize:'20px',
              color: 'white',
              background:'black',
              minWidth:'150px',
              border:'1px solid white'
            }}>Calculate</Button>
        </form>
        {
          result ?
            <DataCard name="Waste heat generated per year:" value={`${result} MWh`} /> : <div></div>
        }
      </div>
    </FadeIn>
  )
}

export default WasteHeatCalculator